export const gqlQueryGetJobService = /* GraphQL */`
  query QueryGetJobService($user_id: String!, $job_id: String!) {
    getJobService(user_id: $user_id, job_id: $job_id) {
      user_id
      job_id
      locality
      status
      stage
      JOB_ROUTE_INPROGRESS
      JOB_WORK_INPROGRESS
      customer {
        user_id
        name
        email
        phone_number
      }
      premise {
        premise_id
        type
        name
        address {
          address1
          address2
          poscode
          city
          state
          country
        }
        place {
          country
          municipality
          neighborhood
          postal_code
          region
          subregion
        }
        location {
          latitude
          longitude
        }
        phase_type
        created
        modified
      }
      phase_type
      service_type
      invoice {
        id
        account_country
        account_name
        amount_due
        amount_overpaid
        amount_paid
        amount_remaining
        amount_shipping
        application_fee_amount
        billing_reason
        charge
        collection_method
        created
        currency
        customer
        customer_email
        customer_name
        customer_phone
        customer_shipping
        description
        hosted_invoice_url
        invoice_pdf
        lines {
          object
          data {
            id
            amount
            amount_excluding_tax
            currency
            description
            price {
              id
              billing_scheme
              currency
              type
              unit_amount
            }
            quantity
          }
        }
        number
        payment_intent
        status
        subtotal
        subtotal_excluding_tax
        total
        total_excluding_tax
      }
      product {
        id
        name
        description
        images
        metadata {
          category
          size
          subtype
          title
          type
        }
        quantity
        default_price {
          id
          billing_scheme
          currency
          type
          unit_amount
        }
      }
      customer_stripe_id
      technician {
        individual {
          name
          race
          gender
          address {
            address1
            address2
            poscode
            city
            state
            country
          }
          identification_number
          identification_number_image {
            bucket
            key
          }
          user_id
          email
          phone_number
          picture {
            bucket
            key
          }
        }
        electrical_competency {
          electrical_wiring {
            not_applicable
            years_of_experience
            highest_level
            file {
              bucket
              key
            }
          }
          chargeman {
            not_applicable
            years_of_experience
            highest_level
            file {
              bucket
              key
            }
          }
        }
        notifications {
          endpoint
        }
      }
      schedule {
        type
        timestamp
        time {
          hour
          minute
        }
      }
      job_rating_technician {
        rating
        remarks
        timestamp
      }
      technician_rating {
        total
        count
      }
      listed_date
      technician_lookup_starttime
      vehicle {
        partner_id
        transport_id
        name
        registration_number
        type
        created
        modified
      }
      purchase_request {
        user_id
        job_id
        purchase_id
        total_quantity
        data {
          status
          products {
            product_id
            quantity
            product {
              id
              name
              description
              images
              metadata {
                category
                size
                subtype
                title
                type
              }
              quantity
              default_price {
                id
                billing_scheme
                currency
                type
                unit_amount
              }
            }
          }
          request_schedule
          make_good {
            id
            name
            description
            images
            metadata {
              category
              size
              subtype
              title
              type
            }
            quantity
            default_price {
              id
              billing_scheme
              currency
              type
              unit_amount
            }
          }
          created
          modified
          purchased_date
          invoice {
            id
            account_country
            account_name
            amount_due
            amount_overpaid
            amount_paid
            amount_remaining
            amount_shipping
            application_fee_amount
            billing_reason
            charge
            collection_method
            created
            currency
            customer
            customer_email
            customer_name
            customer_phone
            customer_shipping
            description
            hosted_invoice_url
            invoice_pdf
            lines {
              object
              data {
                id
                amount
                amount_excluding_tax
                currency
                description
                price {
                  id
                  billing_scheme
                  currency
                  type
                  unit_amount
                }
                quantity
              }
            }
            number
            payment_intent
            status
            subtotal
            subtotal_excluding_tax
            total
            total_excluding_tax
          }
        }
      }
      created
      modified
    }
  }
`